module.exports = __webpack_public_path__ + "static/media/19333445.1cdab9ca.svg";